/* AUTO-GENERATED HOLIDAYS DATA - DO NOT EDIT MANUALLY */
/* Range: BS 2070 - BS 2089 */

export interface Holiday {
  date: string; // YYYY-MM-DD (BS)
  name: string;
}

export const HOLIDAY_DATA: Record<string, Holiday[]> = {
  "2070": [],
  "2071": [],
  "2072": [],
  "2073": [],
  "2074": [],
  "2075": [],
  "2076": [],
  "2077": [],
  "2078": [
    {
      "date": "2078-01-01",
      "name": "नयाँ वर्ष / मेष संक्रान्ति / बिस्का: जात्रा/मत्स्य जयन्ती व्रत"
    },
    {
      "date": "2078-01-18",
      "name": "अन्तर्राष्ट्रिय श्रमिक दिवस"
    },
    {
      "date": "2078-01-31",
      "name": "ईद उल फितर/अक्षय तृतीया व्रत/परशुराम जयन्ती"
    },
    {
      "date": "2078-02-12",
      "name": "बुद्ध जयन्ती / उभौली पर्व/कुर्म जयन्ती / गोरखनाथ जयन्ती/चण्डी पूर्णिमा व्रत/बैसाख स्नान समाप्ति"
    },
    {
      "date": "2078-02-15",
      "name": "गणतन्त्र दिवस"
    },
    {
      "date": "2078-04-06",
      "name": "ईद उल अधा"
    },
    {
      "date": "2078-05-06",
      "name": "जनै पूर्णिमा / रक्षा बन्धन/क्वाटी खाने दिन/संस्कृत दिवस"
    },
    {
      "date": "2078-05-07",
      "name": "गाईजात्रा (बागमती प्रदेश विदा)"
    },
    {
      "date": "2078-05-14",
      "name": "श्रीकृष्ण जन्माष्टमी/गौरा पर्व/दुर्वाष्टमी/विश्व बेपत्ता विरुद्धको दिवस"
    },
    {
      "date": "2078-05-24",
      "name": "हरितालिका तीज व्रत (महिला विदा)"
    },
    {
      "date": "2078-06-03",
      "name": "संविधान दिवस/इन्द्रजात्रा/अनन्त चतुर्दशी व्रत"
    },
    {
      "date": "2078-06-13",
      "name": "जितियापर्व (जितिया पर्व मनाउने महिला कर्मचारीलाई मात्र)/अष्टमी श्राद्ध/बुधाष्टमी/विश्व मुटु दिवस"
    },
    {
      "date": "2078-06-21",
      "name": "घटस्थापना / नवरात्र आरम्भ"
    },
    {
      "date": "2078-06-26",
      "name": "फूलपाती"
    },
    {
      "date": "2078-06-27",
      "name": "महाअष्टमी/विश्व प्राकृतिक प्रकोप नियन्त्रण दिवस"
    },
    {
      "date": "2078-06-28",
      "name": "महानवमी/विश्व दृष्टि दिवस"
    },
    {
      "date": "2078-06-29",
      "name": "विजया दशमी/देवी विसर्जन/अन्तर्राष्ट्रिय ग्रामीण महिला दिवस / विश्व हातधुने दिवस"
    },
    {
      "date": "2078-06-30",
      "name": "पापांकुशा एकादशी व्रत/विश्व खाद्य दिवस"
    },
    {
      "date": "2078-07-18",
      "name": "लक्ष्मी पुजा / महाकवी लक्ष्मीप्रसाद देवकोटाको जन्म जयन्ती/सुखरात्री"
    },
    {
      "date": "2078-07-19",
      "name": "गोवर्धन पूजा/म्हपूजा/हलि तिहार/नेपाल सम्वत ११४२ प्रारम्भ/गाईगोरु पूजा"
    },
    {
      "date": "2078-07-20",
      "name": "भाइटीका / किजा पूजा"
    },
    {
      "date": "2078-07-21",
      "name": "तिहार बिदा"
    },
    {
      "date": "2078-07-24",
      "name": "छठपर्व व्रत/शान्ति र विकासका लागि विश्व विज्ञान दिवस"
    },
    {
      "date": "2078-07-25",
      "name": "महागुरु फाल्गुनन्द जयन्ती (किरात धर्मावलम्बीहरुलाई मात्र)"
    },
    {
      "date": "2078-08-03",
      "name": "गुरु नानक जयन्ती (सिख धर्मावलम्बीहरुलाई मात्र)/चतुर्मास व्रत समाप्ति /कार्तिक स्नान समाप्ति/निम्बार्काचार्य जयन्ती/विश्व शौचालय दिवस"
    },
    {
      "date": "2078-08-17",
      "name": "बाला चतुर्दशी व्रत /शतबीज छर्ने/अन्तर्राष्ट्रिय अपाङ्ग दिवस (अपाङ्गता भएका कर्मचारी मात्र)"
    },
    {
      "date": "2078-09-04",
      "name": "उधौली पर्व / धान्यपुर्णिमा/योमरीपुन्हि"
    },
    {
      "date": "2078-09-10",
      "name": "क्रिसमस-डे"
    },
    {
      "date": "2078-09-15",
      "name": "सफला एकादशी व्रत/तमु ल्होसार"
    },
    {
      "date": "2078-10-01",
      "name": "माघे संक्रान्ति / मकर संक्रान्ति / घ्यु चाकु खाने दिन/उत्तरायण आरम्भ/मकर स्नान आरम्भ"
    },
    {
      "date": "2078-10-19",
      "name": "सोनाम ल्होछार/श्रीबल्लभ जयन्ती/विश्व सिमसार दिवस"
    },
    {
      "date": "2078-10-23",
      "name": "वसन्तपञ्चमी व्रत /सरस्वती पूजा (शिक्षण संस्था विदा)"
    },
    {
      "date": "2078-11-07",
      "name": "प्रजातन्त्र दिवस / निर्वाचन दिवस"
    },
    {
      "date": "2078-11-17",
      "name": "महा शिवरात्री / नेपाली सेना दिवस"
    },
    {
      "date": "2078-11-19",
      "name": "ग्याल्पो ल्होसार"
    },
    {
      "date": "2078-11-24",
      "name": "नारी दिवस"
    },
    {
      "date": "2078-12-03",
      "name": "फागु पुर्णिमा (पहाडी जिल्ला)/पूर्णिमा व्रत"
    },
    {
      "date": "2078-12-04",
      "name": "फागु पुर्णिमा (तराइ होली)"
    },
    {
      "date": "2078-12-18",
      "name": "घोडे जात्रा (काठमाडौँ उपत्यका मात्र विदा)/विश्व मूर्ख दिवस"
    }
  ],
  "2079": [
    {
      "date": "2079-01-01",
      "name": "नयाँ वर्ष / मेष संक्रान्ति / बिस्का: जात्रा/महावीर जयन्ती/प्रदोष व्रत"
    },
    {
      "date": "2079-01-18",
      "name": "अन्तर्राष्ट्रिय श्रमिक दिवस/ललितपुर मत्स्यन्द्रनाथ रथारोहण"
    },
    {
      "date": "2079-01-20",
      "name": "ईद उल फितर/अक्षय तृतीया व्रत/परशुराम जयन्ती/विश्व प्रेस स्वतन्त्रता दिवस"
    },
    {
      "date": "2079-01-30",
      "name": "स्थानीय तह निर्वाचन २०७९/प्रदोष व्रत"
    },
    {
      "date": "2079-02-02",
      "name": "बुद्ध जयन्ती / उभौली पर्व/गोरखनाथ जयन्ती/चण्डी पूर्णिमा व्रत/बैसाख स्नान समाप्ति"
    },
    {
      "date": "2079-02-15",
      "name": "गणतन्त्र दिवस/बटसावित्री व्रत"
    },
    {
      "date": "2079-03-26",
      "name": "हरिशयनी एकादशी व्रत (तुलसी रोप्ने)/चतुर्मास व्रत आरम्भ/बकर इद (ईद ऊल जोहा)"
    },
    {
      "date": "2079-04-27",
      "name": "जनै पूर्णिमा / रक्षा बन्धन/गाईजात्रा/ऋषितर्पणी/क्वाति खाने दिन/संस्कृत दिवस"
    },
    {
      "date": "2079-05-03",
      "name": "श्रीकृष्ण जन्माष्टमी/रामेछाप चिसापानी हिले जात्रा/गूङा नवमी"
    },
    {
      "date": "2079-05-14",
      "name": "हरितालिका तीज व्रत (महिला विदा)/विश्व बेपत्ता विरुद्धको दिवस"
    },
    {
      "date": "2079-05-24",
      "name": "इन्द्रजात्रा/अनन्त चतुर्दशी व्रत/पूर्णिमा व्रत"
    },
    {
      "date": "2079-06-02",
      "name": "जितियापर्व /अष्टमी श्राद्ध/जितियापर्व (जितिया पर्व मनाउने महिला कर्मचारीलाई मात्र)/अष्टमी श्राद्ध"
    },
    {
      "date": "2079-06-03",
      "name": "संविधान दिवस/नवमी श्राद्ध"
    },
    {
      "date": "2079-06-10",
      "name": "घटस्थापना / नवरात्र आरम्भ/अन्तराष्ट्रिय परमाणु हतियार निर्मुल दिवस"
    },
    {
      "date": "2079-06-16",
      "name": "फूलपाती/विश्व अहिंसा दिवस"
    },
    {
      "date": "2079-06-17",
      "name": "महाअष्टमी"
    },
    {
      "date": "2079-06-18",
      "name": "महानवमी/स्याकूट्याकू/विश्व पशु दिवस"
    },
    {
      "date": "2079-06-19",
      "name": "विजया दशमी/देवी विसर्जन/विश्व शिक्षक दिवस"
    },
    {
      "date": "2079-06-20",
      "name": "पापांकुशा एकादशी व्रत"
    },
    {
      "date": "2079-06-21",
      "name": "दशैं विदा/प्रदोष व्रत/विश्व मुस्कान दिवस"
    },
    {
      "date": "2079-07-07",
      "name": "लक्ष्मी पुजा / महाकवी लक्ष्मीप्रसाद देवकोटाको जन्म जयन्ती/कुकुर तिहार/नरक चतुर्दशी/सुखरात्री/संयुक्त राष्ट्रसंघ दिवस / विश्व विकास सूचना दिवस"
    },
    {
      "date": "2079-07-08",
      "name": "गाईगोरु पूजा/खण्डग्रास सूर्यग्रहण"
    },
    {
      "date": "2079-07-09",
      "name": "गोवर्धन पूजा/म्हपूजा/हलि तिहार/नेपाल सम्वत ११४३ प्रारम्भ/अन्तरलिङ्गी जनचेतना दिवस"
    },
    {
      "date": "2079-07-10",
      "name": "भाइटीका / किजा पूजा"
    },
    {
      "date": "2079-07-11",
      "name": "तिहार विदा"
    },
    {
      "date": "2079-07-13",
      "name": "छठपर्व व्रत"
    },
    {
      "date": "2079-07-22",
      "name": "खग्रास चन्द्रग्रहण/गुरु नानक जयन्ती (सिख धर्मावलम्बीहरुलाई मात्र)/निम्बार्काचार्य जयन्ती/चतुर्मास व्रत समाप्ति /कार्तिक स्नान समाप्ति/विश्व रेडियोग्राफी दिवस"
    },
    {
      "date": "2079-08-04",
      "name": "प्रतिनिधिसभा तथा प्रदेशसभा सदस्य निर्वाचन / निर्वाचन विदा/उत्पत्तिका एकादशी व्रत/अन्तर्राष्ट्रिय बाल दिवस"
    },
    {
      "date": "2079-08-05",
      "name": "सोम प्रदोष व्रत/निर्वाचन विदा/विश्व टेलिभिजन दिवस"
    },
    {
      "date": "2079-08-22",
      "name": "उधौली पर्व / धान्यपुर्णिमा/य:मरि पुन्हि/अन्तर्राष्ट्रिय मर्यादित महिनावारी दिवस"
    },
    {
      "date": "2079-09-10",
      "name": "क्रिसमस-डे"
    },
    {
      "date": "2079-09-15",
      "name": "तमु ल्होसार"
    },
    {
      "date": "2079-09-27",
      "name": "पृथ्वी जयन्ती / राष्ट्रिय एकता दिवस"
    },
    {
      "date": "2079-10-01",
      "name": "माघे संक्रान्ति / मकर संक्रान्ति / घ्यु चाकु खाने दिन/उत्तरायण आरम्भ/मकर स्नान आरम्भ"
    },
    {
      "date": "2079-10-08",
      "name": "सोनाम ल्होछार/श्रीबल्लभ जयन्ती"
    },
    {
      "date": "2079-10-12",
      "name": "वसन्तपञ्चमी व्रत /सरस्वती पूजा (शिक्षण संस्था विदा)/राष्ट्रिय पुस्तक दिवस/अन्तर्राष्ट्रिय भन्सार दिवस"
    },
    {
      "date": "2079-11-01",
      "name": "कुम्भ संक्रान्ति/विश्व रेडियो दिवस/जनयुद्ध दिवस"
    },
    {
      "date": "2079-11-06",
      "name": "महा शिवरात्री / नेपाली सेना दिवस/सिलाचःह्रे पूजा/शनि प्रदोष व्रत"
    },
    {
      "date": "2079-11-07",
      "name": "प्रजातन्त्र दिवस / निर्वाचन दिवस"
    },
    {
      "date": "2079-11-09",
      "name": "ग्याल्पो ल्होछार/अन्तर्राष्ट्रिय मातृभाषा दिवस"
    },
    {
      "date": "2079-11-22",
      "name": "फागु पुर्णिमा (पहाडी जिल्ला बिदा)"
    },
    {
      "date": "2079-11-23",
      "name": "फागु पुर्णिमा (तराइ बिदा)/पूर्णिमा व्रत"
    },
    {
      "date": "2079-11-24",
      "name": "नारी दिवस/तेल लगाउने र आँपको मुजुरा खाने दिन/गणगौरपूजा प्रारम्भ"
    },
    {
      "date": "2079-12-07",
      "name": "घोडेजात्रा"
    }
  ],
  "2080": [
    {
      "date": "2080-01-01",
      "name": "नयाँ वर्ष / मेष संक्रान्ति / बिस्का: जात्रा"
    },
    {
      "date": "2080-01-09",
      "name": "ईद उल फितर/परशुराम जयन्ती/विश्व पृथ्वी दिवस"
    },
    {
      "date": "2080-01-18",
      "name": "मोहिनी एकादशी व्रत/अन्तर्राष्ट्रिय श्रमिक दिवस"
    },
    {
      "date": "2080-01-22",
      "name": "बुद्ध जयन्ती / उभौली पर्व / चण्डेश्वरी जात्रा/ चण्डी पूर्णिमा/कुर्म जयन्ती / गोरखनाथ जयन्ती/पूर्णिमा व्रत/बैसाख स्नान समाप्ति"
    },
    {
      "date": "2080-02-15",
      "name": "गणतन्त्र दिवस"
    },
    {
      "date": "2080-03-14",
      "name": "हरिशयनी एकादशी व्रत (तुलसी रोप्ने)/ईद उल अधा/चतुर्मास व्रत आरम्भ"
    },
    {
      "date": "2080-05-07",
      "name": "गौरा पर्व (सम्बन्धित क्षेत्रमा बिदा)"
    },
    {
      "date": "2080-05-14",
      "name": "जनै पूर्णिमा / रक्षा बन्धन/गाईजात्रा"
    },
    {
      "date": "2080-05-15",
      "name": "सापारु (गाईजात्रा) (काठमाडौँ बिदा)/रोपाईं जात्रा"
    },
    {
      "date": "2080-05-20",
      "name": "श्रीकृष्ण जन्माष्टमी/मानव बेचबिखन विरुद्धको राष्ट्रिय दिवस"
    },
    {
      "date": "2080-06-01",
      "name": "हरितालिका तीज व्रत (महिला विदा)/विश्वकर्मा पूजा / कन्या संक्रान्ति / राष्ट्रिय चलचित्र दिवस/गणेश चतुर्थी व्रत/राष्ट्रिय धर्मसभा दिवस/वास्तु दिवस"
    },
    {
      "date": "2080-06-03",
      "name": "संविधान दिवस"
    },
    {
      "date": "2080-06-11",
      "name": "इन्द्रजात्रा (काठमाडौँ उपत्यका बिदा)/अनन्त चतुर्दशी व्रत/विश्व रेबिज विरुद्ध दिवस / अन्तर्राष्ट्रिय सूचनामा विश्वव्यापी पहुँचको दिवस"
    },
    {
      "date": "2080-06-20",
      "name": "जितिया पर्व (पर्व मनाउने महिला कर्मचारीलाई मात्र बिदा)/नवमी श्राद्ध"
    },
    {
      "date": "2080-06-28",
      "name": "घटस्थापना / नवरात्र आरम्भ/अन्तर्राष्ट्रिय ग्रामीण महिला दिवस / विश्व हातधुने दिवस"
    },
    {
      "date": "2080-07-04",
      "name": "फूलपाती"
    },
    {
      "date": "2080-07-05",
      "name": "महाअष्टमी/ कालरात्रि"
    },
    {
      "date": "2080-07-06",
      "name": "महानवमी"
    },
    {
      "date": "2080-07-07",
      "name": "विजया दशमी/देवी विसर्जन/संयुक्त राष्ट्रसंघ दिवस / विश्व विकास सूचना दिवस"
    },
    {
      "date": "2080-07-08",
      "name": "पापांकुशा एकादशी व्रत"
    },
    {
      "date": "2080-07-09",
      "name": "दशैं बिदा/प्रदोष व्रत"
    },
    {
      "date": "2080-07-25",
      "name": "काग तिहार/धनवन्तरी जयन्ती/महागुरु फाल्गुनन्द जयन्ती (किराँत धर्मावलम्बीहरूलाई बिदा)"
    },
    {
      "date": "2080-07-26",
      "name": "लक्ष्मी पुजा / महाकवी लक्ष्मीप्रसाद देवकोटाको जन्म जयन्ती/नरक चतुर्दशी/सुखरात्री/कुकुर तिहार"
    },
    {
      "date": "2080-07-27",
      "name": "गाई तिहार/सोमबारे औंसी"
    },
    {
      "date": "2080-07-28",
      "name": "गोवर्धन पूजा / म्ह: पूजा / नेपाल सम्वत ११४४ प्रारम्भ/विश्व मधुमेह दिवस"
    },
    {
      "date": "2080-07-29",
      "name": "भाई टिका / किजा पूजा"
    },
    {
      "date": "2080-07-30",
      "name": "तिहार बिदा/अन्तर्राष्ट्रिय सहनशीलता दिवस"
    },
    {
      "date": "2080-08-03",
      "name": "छठपर्व व्रत/विश्व शौचालय दिवस"
    },
    {
      "date": "2080-08-11",
      "name": "गुरु नानक जयन्ती (सिख धर्मावलम्बीहरुलाई मात्र बिदा)/निम्बार्काचार्य जयन्ती/चतुर्मास व्रत समाप्ति /कार्तिक स्नान समाप्ति"
    },
    {
      "date": "2080-08-17",
      "name": "अन्तर्राष्ट्रिय अपाङ्ग दिवस (अपाङ्गता भएका कर्मचारी मात्र बिदा)"
    },
    {
      "date": "2080-09-09",
      "name": "क्रिसमस-डे"
    },
    {
      "date": "2080-09-10",
      "name": "उधौली पर्व / धान्यपुर्णिमा/य:मरि पुन्हि / ज्यापु दिवस/पूर्णिमा व्रत/दत्तात्रेय जयन्ती"
    },
    {
      "date": "2080-09-15",
      "name": "तमु ल्होसार"
    },
    {
      "date": "2080-09-27",
      "name": "पृथ्वी जयन्ती / राष्ट्रिय एकता दिवस/तोल ल्होसार"
    },
    {
      "date": "2080-10-01",
      "name": "माघे संक्रान्ति / मकर संक्रान्ति / घ्यु चाकु खाने दिन / मकर स्नान आरम्भ/उत्तरायण आरम्भ"
    },
    {
      "date": "2080-10-27",
      "name": "सोनाम ल्होछार/श्रीबल्लभ जयन्ती"
    },
    {
      "date": "2080-11-02",
      "name": "वसन्तपञ्चमी व्रत /सरस्वती पूजा (शिक्षण संस्था बिदा)/प्रणय दिवस/राष्ट्रिय पुस्तक दिवस"
    },
    {
      "date": "2080-11-07",
      "name": "प्रजातन्त्र दिवस / निर्वाचन दिवस"
    },
    {
      "date": "2080-11-25",
      "name": "महाशिवरात्रि व्रत/नेपाली सेना दिवस/सिलाचःह्रे पूजा/नारी दिवस/प्रदोष व्रत"
    },
    {
      "date": "2080-11-28",
      "name": "ग्याल्पो ल्होछार"
    },
    {
      "date": "2080-12-11",
      "name": "फागु पुर्णिमा (पहाडी जिल्ला)/पूर्णिमा व्रत/विश्व क्षयरोग दिवस"
    },
    {
      "date": "2080-12-12",
      "name": "फागु पुर्णिमा (तराइ बिदा)"
    },
    {
      "date": "2080-12-26",
      "name": "घोडेजात्रा (काठमाडौँ उपत्यकालाई बिदा)/सोमबारे औंसी"
    },
    {
      "date": "2080-12-29",
      "name": "ईद उल फितर/मत्स्य जयन्ती व्रत/मत्स्यनारायण मेला/गौरी व्रत"
    }
  ],
  "2081": [
    {
      "date": "2081-01-01",
      "name": "नयाँ वर्ष/मेष संक्रान्ति/बिस्का: जात्रा"
    },
    {
      "date": "2081-01-05",
      "name": "श्री राम नवमी व्रत"
    },
    {
      "date": "2081-01-19",
      "name": "अन्तर्राष्ट्रिय श्रमिक दिवस/बुधाष्टमी व्रत/गोरखकाली पूजा"
    },
    {
      "date": "2081-02-10",
      "name": "बुद्ध जयन्ती/उभौली पर्व/चण्डेश्वरी जात्रा/चण्डी पूर्णिमा/कुर्म जयन्ती/गोरखनाथ जयन्ती/पूर्णिमा व्रत/बैसाख स्नान समाप्ति"
    },
    {
      "date": "2081-02-15",
      "name": "गणतन्त्र दिवस"
    },
    {
      "date": "2081-03-03",
      "name": "बक्र ईद (उल–अजहा)/विश्व खडेरी विरुद्ध संघर्ष दिवस/स्मार्तहरूको निर्जला एकादशी व्रत"
    },
    {
      "date": "2081-04-20",
      "name": "भोटो जात्रा (उपत्यका विदा)"
    },
    {
      "date": "2081-05-03",
      "name": "जनै पूर्णिमा/रक्षा बन्धन/क्वाति खाने दिन/पूर्णिमा व्रत/ऋषितर्पणी/संस्कृत दिवस/विश्व फोटोग्राफी दिवस"
    },
    {
      "date": "2081-05-04",
      "name": "गाईजात्रा (नेवा समुदायलाई मात्र)"
    },
    {
      "date": "2081-05-10",
      "name": "श्रीकृष्ण जन्माष्टमी/गाैरा पर्व (सम्बन्धित समुदायलाई मात्र)/गोरखकाली पूजा"
    },
    {
      "date": "2081-05-21",
      "name": "हरितालिका तीज (महिला कर्मचारीहरूलाई मात्र)"
    },
    {
      "date": "2081-06-01",
      "name": "विश्वकर्मा पूजा/कन्या संक्रान्ति/इन्द्रजात्रा (उपत्यका बिदा)/राष्ट्रिय चलचित्र दिवस/वास्तु दिवस/अनन्त चतुर्दशी व्रत/पूर्णिमा व्रत/विश्व बिरामी सुरक्षा दिवस/राष्ट्रिय विज्ञान दिवस"
    },
    {
      "date": "2081-06-03",
      "name": "संविधान दिवस/द्वितीया श्राद्ध"
    },
    {
      "date": "2081-06-09",
      "name": "अष्टमी श्राद्ध/बुधाष्टमी/गोरखकाली पूजा/जितियापर्व (पर्व मनाउने महिलाहरूलाई बिदा)/विश्व फार्मासिस्ट दिवस"
    },
    {
      "date": "2081-06-17",
      "name": "घटस्थापना व्रत/नवरात्र आरम्भ"
    },
    {
      "date": "2081-06-24",
      "name": "फूलपाती/विश्व दृष्टि दिवस/विश्व मानसिक स्वास्थ्य दिवस"
    },
    {
      "date": "2081-06-25",
      "name": "महाअष्टमी व्रत/कालरात्रि/महानवमी व्रत/गैर आवासीय नेपाली दिवस/गोरखकाली पूजा"
    },
    {
      "date": "2081-06-26",
      "name": "विजया दशमी/देवी विसर्जन"
    },
    {
      "date": "2081-06-27",
      "name": "पापांकुशा एकादशी व्रत/अन्तर्राष्ट्रिय प्रकोप जोखिम न्यूनीकरण दिवस"
    },
    {
      "date": "2081-06-28",
      "name": "दशैं विदा"
    },
    {
      "date": "2081-07-15",
      "name": "लक्ष्मी पूजा/महाकवी लक्ष्मीप्रसाद देवकोटाको जन्म जयन्ती/कुकुर तिहार/नरक चतुर्दशी/सुखरात्री/विश्व शहरीकरण दिवस"
    },
    {
      "date": "2081-07-16",
      "name": "तिहार बिदा"
    },
    {
      "date": "2081-07-17",
      "name": "गोवर्धन पूजा/गाईगोरु पूजा/म्हपूजा/हलि तिहार/नेपाल सम्वत ११४५ प्रारम्भ"
    },
    {
      "date": "2081-07-18",
      "name": "भाइटीका/किजा पूजा"
    },
    {
      "date": "2081-07-19",
      "name": "तिहार बिदा"
    },
    {
      "date": "2081-07-22",
      "name": "छठ पर्व"
    },
    {
      "date": "2081-07-25",
      "name": "कुष्मान्ड नवमी व्रत/महागुरु फाल्गुनन्द जयन्ती (किराँत धर्मावलम्बीहरूलाई मात्र)/शान्ति र विकासको लागि विश्व विज्ञान दिवस"
    },
    {
      "date": "2081-07-30",
      "name": "गुरु नानक जयन्ती (सिख धर्मावलम्बीहरूलाई मात्र)/निम्बार्काचार्य जयन्ती/चतुर्मास व्रत समाप्ति/कार्तिक स्नान समाप्ति/पूर्णिमा व्रत"
    },
    {
      "date": "2081-08-18",
      "name": "अन्तर्राष्ट्रिय अपाङ्ग दिवस (विशेष क्षमता भएका कर्मचारीलाई मात्र)"
    },
    {
      "date": "2081-08-30",
      "name": "उधौली पर्व/धान्यपुर्णिमा/य:मरि पुन्हि/ज्यापु दिवस/गढीमाई मेला समाप्ती"
    },
    {
      "date": "2081-09-10",
      "name": "क्रिसमस-डे"
    },
    {
      "date": "2081-09-15",
      "name": "तमु ल्होसार/सोमबारे औंसी/कवि शिरोमणि लेखनाथ जयन्ती"
    },
    {
      "date": "2081-09-27",
      "name": "पृथ्वी जयन्ती/राष्ट्रिय एकता दिवस/शनि प्रदोष व्रत"
    },
    {
      "date": "2081-10-01",
      "name": "माघे संक्रान्ति/घ्यु चाकु खाने दिन/उत्तरायण आरम्भ"
    },
    {
      "date": "2081-10-16",
      "name": "शहीद दिवस"
    },
    {
      "date": "2081-10-17",
      "name": "सोनाम ल्होछार/श्रीबल्लभ जयन्ती"
    },
    {
      "date": "2081-11-07",
      "name": "प्रजातन्त्र दिवस/निर्वाचन दिवस"
    },
    {
      "date": "2081-11-14",
      "name": "महाशिवरात्रि व्रत/सिलाचःह्रे पूजा/सेना दिवस"
    },
    {
      "date": "2081-11-16",
      "name": "ग्याल्पो ल्होछार"
    },
    {
      "date": "2081-11-24",
      "name": "अन्तर्राष्ट्रिय नारी दिवस"
    },
    {
      "date": "2081-11-29",
      "name": "फागु पुर्णिमा (पहाडी जिल्ला)/पूर्णिमा व्रत"
    },
    {
      "date": "2081-12-01",
      "name": "मीन संक्रान्ति/फागु पुर्णिमा (तराई होली)/विश्व उपभोक्ता अधिकार दिवस"
    },
    {
      "date": "2081-12-16",
      "name": "घोडे जात्रा (उपत्यका बिदा)/विश्व नेवाः दिवस/शीतलाष्टमी व्रत"
    },
    {
      "date": "2081-12-18",
      "name": "ईद उल फितर/मत्स्य जयन्ती व्रत/मत्स्यनारायण मेला"
    },
    {
      "date": "2081-12-24",
      "name": "रामनवमी व्रत/अन्तर्राष्ट्रिय विकास र शान्तिको लागि खेलकुद दिवस"
    }
  ],
  "2082": [
    {
      "date": "2082-01-01",
      "name": "नयाँ वर्ष/मेष संक्रान्ति/बिस्का: जात्रा"
    },
    {
      "date": "2082-01-18",
      "name": "अन्तर्राष्ट्रिय श्रमिक दिवस/बुंगद्यः (रातो मच्छिन्द्रनाथ) रथ यात्रा प्रारम्भ"
    },
    {
      "date": "2082-01-24",
      "name": "प्रदेश सरकारको सरकारी कामकाजको भाषा सम्बन्धी दिवस(बागमती प्रदेशका लागि मात्र)/किराँत समाज सुधार दिवस"
    },
    {
      "date": "2082-01-29",
      "name": "बुद्ध जयन्ती/उभौली पर्व/चण्डेश्वरी जात्रा/चण्डी पूर्णिमा/कुर्म जयन्ती/गोरखनाथ जयन्ती/पूर्णिमा व्रत/बैसाख स्नान समाप्ति/अन्तर्राष्ट्रिय नर्स दिवस"
    },
    {
      "date": "2082-02-15",
      "name": "गणतन्त्र दिवस"
    },
    {
      "date": "2082-02-18",
      "name": "भोटो जात्रा (उपत्यका विदा)/सिथि नख:/विश्व बुवाआमा दिवस"
    },
    {
      "date": "2082-02-24",
      "name": "निर्जला एकादशी व्रत (तुलसीको दल राख्ने)/बकर ईद (ईद-उल-अज्हा)"
    },
    {
      "date": "2082-04-24",
      "name": "जनै पूर्णिमा/रक्षा बन्धन/क्वाति खाने दिन/पूर्णिमा व्रत/ऋषितर्पणी/संस्कृत दिवस/अन्तर्राष्ट्रिय आदिवासी दिवस/अन्तर्राष्ट्रिय भू संरक्षण दिवस"
    },
    {
      "date": "2082-04-25",
      "name": "गाईजात्रा (बागमती प्रदेशका लागि मात्र)"
    },
    {
      "date": "2082-04-31",
      "name": "श्रीकृष्ण जन्माष्टमी/गोरखकाली पूजा"
    },
    {
      "date": "2082-05-10",
      "name": "हरितालिका तीज (महिला कर्मचारीहरूलाई मात्र)"
    },
    {
      "date": "2082-05-15",
      "name": "राधा जन्मोत्सव/गाैरा पर्व (सम्बन्धित समुदायलाई मात्र)/गोरखकाली पूजा/दुर्वाष्टमी/राष्ट्रिय पुस्तकालय दिवस"
    },
    {
      "date": "2082-05-21",
      "name": "इन्द्रजात्रा (काठमाडौं उपत्यका बिदा)/अनन्त चतुर्दशी व्रत"
    },
    {
      "date": "2082-05-30",
      "name": "नवमी श्राद्ध/जितियापर्व (पर्व मनाउने महिलाहरूलाई बिदा)"
    },
    {
      "date": "2082-06-01",
      "name": "जेनजी आन्दोलन (शोक बिदा)/विश्वकर्मा पूजा/इन्दिरा एकादशी व्रत/एकादशी श्राद्ध/कन्या संक्रान्ति/वास्तु दिवस/राष्ट्रिय विज्ञान दिवस/विश्व बिरामी सुरक्षा दिवस"
    },
    {
      "date": "2082-06-03",
      "name": "त्रयोदशी श्राद्ध/मघा श्राद्ध/संविधान दिवस"
    },
    {
      "date": "2082-06-06",
      "name": "घटस्थापना व्रत/नवरात्र आरम्भ"
    },
    {
      "date": "2082-06-13",
      "name": "फूलपाती/विश्व मुटु दिवस"
    },
    {
      "date": "2082-06-14",
      "name": "महाअष्टमी व्रत/कालरात्रि/गोरखकाली पूजा/भाैमाष्टमी व्रत"
    },
    {
      "date": "2082-06-15",
      "name": "महानवमी व्रत/राष्ट्रिय चलचित्र दिवस/अन्तर्राष्ट्रिय ज्येष्ठ नागरिक दिवस"
    },
    {
      "date": "2082-06-16",
      "name": "विजया दशमी/देवी विसर्जन/विश्व अहिंसा दिवस"
    },
    {
      "date": "2082-06-17",
      "name": "2082-06-17/विश्व मुस्कान दिवस"
    },
    {
      "date": "2082-06-18",
      "name": "दशैं विदा/शनि प्रदोष व्रत/विश्व पशु दिवस"
    },
    {
      "date": "2082-07-03",
      "name": "लक्ष्मी पूजा/कुकुर तिहार/महाकवि लक्ष्मीप्रसाद देवकोटाको जन्म जयन्ती/नरक चतुर्दशी/सुखरात्री"
    },
    {
      "date": "2082-07-04",
      "name": "तिहार बिदा"
    },
    {
      "date": "2082-07-05",
      "name": "गोवर्धन पूजा/गाईगोरु पूजा/म्हपूजा/हलि तिहार/नेपाल सम्वत ११४६ प्रारम्भ"
    },
    {
      "date": "2082-07-06",
      "name": "भाइटीका/किजा पूजा"
    },
    {
      "date": "2082-07-07",
      "name": "तिहार बिदा/संयुक्त राष्ट्रसंघ दिवस/विश्व विकास सूचना दिवस"
    },
    {
      "date": "2082-07-10",
      "name": "छठ पर्व"
    },
    {
      "date": "2082-07-19",
      "name": "पूर्णिमा व्रत/सकिमना पुन्हि/चतुर्मास व्रत समाप्ति /कार्तिक स्नान समाप्ति/निम्बार्काचार्य जयन्ती/गुरु नानक जयन्ती (सिख धर्मावलम्बीहरूलाई मात्र)"
    },
    {
      "date": "2082-07-25",
      "name": "महागुरु फाल्गुनन्द जयन्ती (किराँत धर्मावलम्बीहरूलाई मात्र)"
    },
    {
      "date": "2082-08-17",
      "name": "अन्तर्राष्ट्रिय अपाङ्ग दिवस (विशेष क्षमता भएका कर्मचारीलाई मात्र)"
    },
    {
      "date": "2082-08-18",
      "name": "उँधौली पर्व/य:मरि पुन्हि/ज्यापु दिवस/पूर्णिमा व्रत/धान्यपुर्णिमा"
    },
    {
      "date": "2082-09-10",
      "name": "क्रिसमस-डे"
    },
    {
      "date": "2082-09-15",
      "name": "तमु ल्होसार/कवि शिरोमणि लेखनाथ जयन्ती/पुत्रदा एकादशी व्रत"
    },
    {
      "date": "2082-09-27",
      "name": "पृथ्वी जयन्ती/राष्ट्रिय एकता दिवस/गोरखकाली पूजा"
    },
    {
      "date": "2082-10-01",
      "name": "माघे संक्रान्ति/घ्यु चाकु खाने दिन/उत्तरायण आरम्भ/राष्ट्रिय योग दिवस"
    },
    {
      "date": "2082-10-05",
      "name": "सोनाम ल्होछार/श्री वल्लभ जयन्ती"
    },
    {
      "date": "2082-10-09",
      "name": "वसन्तपञ्चमी व्रत/सरस्वती पूजा (शिक्षण संस्था बिदा)"
    },
    {
      "date": "2082-10-16",
      "name": "शहीद दिवस/प्रदोष व्रत"
    },
    {
      "date": "2082-11-03",
      "name": "महाशिवरात्रि/नेपाली सेना दिवस/सिलाचःह्रे पूजा"
    },
    {
      "date": "2082-11-06",
      "name": "ग्याल्पो ल्होसार"
    },
    {
      "date": "2082-11-07",
      "name": "प्रजातन्त्र दिवस/रमदान महिना शुरू/निर्वाचन दिवस"
    },
    {
      "date": "2082-11-18",
      "name": "फागु पुर्णिमा (पहाडी जिल्ला)/पूर्णिमा व्रत"
    },
    {
      "date": "2082-11-19",
      "name": "फागु पुर्णिमा (तराइ होली)/खण्डग्रास चन्द्र ग्रहण/विश्व वन्यजन्तु दिवस"
    },
    {
      "date": "2082-11-20",
      "name": "चुनाव बिदा २०८२/तेल लगाउने र आँपको मुजुरा खाने दिन"
    },
    {
      "date": "2082-11-21",
      "name": "प्रतिनिधिसभा निर्वाचन २०८२"
    },
    {
      "date": "2082-11-22",
      "name": "चुनाव बिदा २०८२"
    },
    {
      "date": "2082-11-24",
      "name": "नारी दिवस"
    },
    {
      "date": "2082-12-04",
      "name": "घोडेजात्रा (काठमाडौँ उपत्यकालाई बिदा)"
    },
    {
      "date": "2082-12-07",
      "name": "ईद उल फितर/गौरी व्रत/मत्स्य जयन्ती व्रत/विश्व कविता दिवस"
    },
    {
      "date": "2082-12-13",
      "name": "श्री राम नवमी व्रत/विश्व रङ्गमञ्च दिवस"
    }
  ],
  "2083": [
    {
      "date": "2083-01-01",
      "name": "नयाँ वर्ष / वैशाख संक्रान्ति / बिस्का: जात्रा"
    },
    {
      "date": "2083-01-18",
      "name": "बुद्ध जयन्ती / उभौली पर्व / चण्डी पूर्णिमा / मजदुर दिवस"
    },
    {
      "date": "2083-02-15",
      "name": "गणतन्त्र दिवस / अन्तर्राष्ट्रिय सगरमाथा दिवस"
    },
    {
      "date": "2083-05-12",
      "name": "जनै पूर्णिमा / रक्षाबन्धन / ऋषितर्पणी / संस्कृत दिवस"
    },
    {
      "date": "2083-05-13",
      "name": "गाईजात्रा (काठमाडौँ उपत्यका बिदा)"
    },
    {
      "date": "2083-05-19",
      "name": "श्री कृष्ण जन्माष्टमी / गौरा पर्व"
    },
    {
      "date": "2083-05-29",
      "name": "हरितालिका तीज व्रत (महिला कर्मचारीहरूलाई मात्र)"
    },
    {
      "date": "2083-05-30",
      "name": "ऋषि पञ्चमी (महिला कर्मचारीहरूलाई मात्र)"
    },
    {
      "date": "2083-06-03",
      "name": "संविधान दिवस"
    },
    {
      "date": "2083-06-09",
      "name": "इन्द्रजात्रा (काठमाडौँ उपत्यका बिदा) / अनन्त चतुर्दशी"
    },
    {
      "date": "2083-06-18",
      "name": "जितिया पर्व (महिला कर्मचारीहरूलाई मात्र)"
    },
    {
      "date": "2083-06-25",
      "name": "घटस्थापना / नवरात्र आरम्भ"
    },
    {
      "date": "2083-06-31",
      "name": "फूलपाती / दशैं बिदा"
    },
    {
      "date": "2083-07-01",
      "name": "महा अष्टमी / दशैं बिदा"
    },
    {
      "date": "2083-07-02",
      "name": "दशैं बिदा"
    },
    {
      "date": "2083-07-03",
      "name": "महानवमी / दशैं बिदा"
    },
    {
      "date": "2083-07-04",
      "name": "विजया दशमी / दशैं बिदा"
    },
    {
      "date": "2083-07-05",
      "name": "पापांकुशा एकादशी / दशैं बिदा"
    },
    {
      "date": "2083-07-06",
      "name": "दशैं बिदा"
    },
    {
      "date": "2083-07-22",
      "name": "लक्ष्मी पूजा / कुकुर तिहार / दीपावली"
    },
    {
      "date": "2083-07-23",
      "name": "गाई पूजा / तिहार बिदा"
    },
    {
      "date": "2083-07-24",
      "name": "गोवर्धन पूजा / म्हपूजा / नेपाल सम्वत ११४७ प्रारम्भ / तिहार बिदा"
    },
    {
      "date": "2083-07-25",
      "name": "भाइटीका / किजा पूजा / फाल्गुनन्द जयन्ती / तिहार बिदा"
    },
    {
      "date": "2083-07-26",
      "name": "तिहार बिदा"
    },
    {
      "date": "2083-07-29",
      "name": "छठ पर्व"
    },
    {
      "date": "2083-08-08",
      "name": "गुरु नानक जयन्ती"
    },
    {
      "date": "2083-08-17",
      "name": "विश्व अपाङ्गता दिवस"
    },
    {
      "date": "2083-08-18",
      "name": "उधौली पर्व / धान्य पूर्णिमा पूर्वसन्ध्या"
    },
    {
      "date": "2083-09-09",
      "name": "उधौली पर्व / धान्य पूर्णिमा / योमरी पुन्ही"
    },
    {
      "date": "2083-09-10",
      "name": "क्रिसमस डे"
    },
    {
      "date": "2083-09-15",
      "name": "तमु ल्होसार"
    },
    {
      "date": "2083-09-27",
      "name": "पृथ्वी जयन्ती / राष्ट्रिय एकता दिवस"
    },
    {
      "date": "2083-10-01",
      "name": "माघे संक्रान्ति / माघी पर्व"
    },
    {
      "date": "2083-10-16",
      "name": "सहिद दिवस"
    },
    {
      "date": "2083-10-24",
      "name": "सोनाम ल्होछार / तामाङ ल्होछार"
    },
    {
      "date": "2083-10-28",
      "name": "वसन्त पञ्चमी / सरस्वती पूजा"
    },
    {
      "date": "2083-11-07",
      "name": "प्रजातन्त्र दिवस"
    },
    {
      "date": "2083-11-22",
      "name": "महाशिवरात्रि / सेना दिवस"
    },
    {
      "date": "2083-11-24",
      "name": "अन्तर्राष्ट्रिय नारी दिवस"
    },
    {
      "date": "2083-11-25",
      "name": "ग्याल्पो ल्होसार"
    },
    {
      "date": "2083-12-07",
      "name": "फागु पूर्णिमा (पहाडी होली)"
    },
    {
      "date": "2083-12-08",
      "name": "फागु पूर्णिमा (तराई होली)"
    },
    {
      "date": "2083-12-23",
      "name": "घोडे जात्रा (काठमाडौँ उपत्यका बिदा)"
    }
  ],
  "2084": [
    {
      "date": "2084-01-01",
      "name": "नयाँ वर्ष २०८३"
    },
    {
      "date": "2084-08-18",
      "name": "उँधौली पर्व"
    }
  ],
  "2085": [
    {
      "date": "2085-01-01",
      "name": "नयाँ वर्ष २०८३"
    }
  ],
  "2086": [],
  "2087": [],
  "2088": [],
  "2089": []
} as const;
